import makeStyles from '@material-ui/core/styles/makeStyles'
import { CancelButton, NextButton, PrevButton, Text } from '../1elements'
import PeopleForm from '../3modules/PeopleImport/PeopleForm'
import SidePeopleList from '../3modules/PeopleImport/SidePeopleList'
import ContactNameSearch from '../2compounds/ContactNameSearch'
import { useEffect, useState } from 'react'
import {
  formatPhoneNumber,
  nameSeparator,
  peopleFormInProgress,
  recordFormatter,
  recordUrlFormatter,
  today
} from '../../services/util/miscellaneousService'
import uuid from 'react-uuid'
import {
  validateDescription,
  validateEffectiveDate,
  validateFirstName,
  validateJobTitle,
  validateLastName, validateOptionalRecordURL,
  validateOrganizationName,
  validatePhoneNumber,
  validateRecordName,
  validateRecordType,
  validateRequiredEmail
} from '../../services/util/editChecks'
import dayjs from 'dayjs'
import ApiService from '../../common/ApiCalls'
import { getItemFromSessionStorage } from '../../services/util/sessionStorageManager'
import SelectApproverModal from '../3modules/SmartForm/SelectApproverModal'
import ErrorSnackbar from '../2compounds/ErrorSnackbar'
import FormErrorSnackbar from '../2compounds/FormErrorSnackbar'
import FormSuccessSnackbar from '../2compounds/FormSuccessSnackbar'
import SelectContactTypeInstruction from '../3modules/PeopleImport/SelectContactTypeInstruction'
import LeaveFormModal from '../2compounds/LeaveFormModal'
import RejectButton from '../1elements/Buttons/TextButtons/RejectButton'
import ApproveButton from '../1elements/Buttons/TextButtons/ApproveButton'
import RejectModal from '../2compounds/RejectModal'
import ApproveModal from '../2compounds/ApproveModal'
import ButtonLayoutDiv from '../4layout/ButtonLayoutDiv'

const PeopleImportTemplate = ({
  selectedContactList, setSelectedContactList, onCancel, onSave, onPrev, isModalOpen, setIsModalOpen,
  onNext, approver, setApprover, formCheckSnackbar, setFormCheckSnackbar, showErrorApprover,
  onReject, onApprove, disabled
}) => {
  const classes = useStyles()
  const [showError, setShowError] = useState(false)
  const [formType, setFormType] = useState('Search Form')
  const [selectedContactType, setSelectedContactType] = useState('')
  const [contactTypeList, setContactTypeList] = useState([])
  const [selectedContactName, setSelectedContact] = useState(null)
  const defaultDraftType = {
    firstName: '',
    lastName: '',
    jobTitle: '',
    assignedDate: today,
    phoneNumber: '',
    email: '',
    description: '',
    records: [{ recordType: '', recordName: '', recordLink: '', expiryDate: null, effectiveDate: null }],
    organization: '',
    organizationName: ''
  }
  const [contactDraft, setContactDraft] = useState(defaultDraftType)
  const [isFormErrorSnackbarOpen, setIsFormErrorSnackbarOpen] = useState(false)
  const [isFormSuccessSnackbarOpen, setIsFormSuccessSnackbarOpen] = useState(false)
  const [isLeaveFormModalOpenPrev, setIsLeaveFormModalOpenPrev] = useState(false)
  const [isLeaveFormModalOpenNext, setIsLeaveFormModalOpenNext] = useState(false)
  const [rejectModalOpen, setRejectModalOpen] = useState(false)
  const [approveModalOpen, setApproveModalOpen] = useState(false)

  const switchFormTypeToSearchForm = () => {
    resetForm()
    setFormType('Search Form')
  }
  const switchFormTypeToManualInput = () => {
    resetForm()
    setFormType('Manual Input')
  }

  const resetForm = () => {
    setShowError(false)
    setContactDraft({ ...defaultDraftType })
  }

  const changeContactType = (contactType) => {
    setSelectedContactType(contactType)
    switchFormTypeToSearchForm()
    resetForm()
  }

  const editContactDraft = (targetData, newValue) => {
    setContactDraft({ ...contactDraft, [targetData]: newValue })
  }

  const editPeopleData = (targetData, newValue) => {
    setContactDraft(prevState => { return { ...prevState, [targetData]: newValue } })
  }

  const contactIdConverter = (selectedContactType) => {
    const contactType = contactTypeList.find((contactType) =>
      contactType.contact_type === selectedContactType)
    return contactType.contact_type_id
  }

  const addNewPerson = () => {
    setShowError(true)
    if (!hasError()) {
      setShowError(false)
      setSelectedContactList(prevState => {
        prevState[selectedContactType].push({
          ...contactDraft,
          id: uuid(),
          phoneNumber: formatPhoneNumber(contactDraft.phoneNumber),
          contactType: selectedContactType,
          contactTypeId: contactIdConverter(selectedContactType),
          isContractor: selectedContactType.toLowerCase().includes('contractor')
        })
        return { ...prevState }
      })
      setContactDraft({ ...defaultDraftType })
      setIsFormSuccessSnackbarOpen(true)
    } else {
      setIsFormErrorSnackbarOpen(true)
    }
  }
  const deletePerson = (index, contactType) => {
    if (selectedContactList[contactType].length > 1) {
      const contactListCopy = selectedContactList[contactType]
      contactListCopy.splice(index, 1)
      setSelectedContactList(prevState => { return { ...prevState, [contactType]: contactListCopy } })
    } else {
      setSelectedContactList(prevState => { return { ...prevState, [contactType]: [] } })
    }
    switchFormTypeToSearchForm()
  }
  const updatePerson = (id) => {
    if (hasError()) {
      setShowError(true)
      setIsFormErrorSnackbarOpen(true)
      return
    }

    setSelectedContactList(prevState => {
      const contactListCopy = prevState[selectedContactType]
      const targetIndex = contactListCopy.findIndex((contact) => {
        return contact.id === id
      })
      prevState[selectedContactType][targetIndex] = contactDraft

      return { ...prevState, [selectedContactType]: contactListCopy }
    })
    setContactDraft(defaultDraftType)
    setIsFormSuccessSnackbarOpen(true)
  }

  const addRecord = () => {
    const newRecordList = [...contactDraft.records,
      { recordType: '', recordName: '', recordLink: '', expiryDate: null, effectiveDate: null }]
    editPeopleData('records', newRecordList)
  }
  const deleteRecord = (index) => {
    let recordListCopy = [...contactDraft.records]
    if (recordListCopy.length > 1) {
      recordListCopy.splice(index, 1)
    } else {
      recordListCopy = [{ recordType: '', recordName: '', recordLink: '', expiryDate: null, effectiveDate: null }]
    }
    editPeopleData('records', recordListCopy)
  }

  const updateRecordData = (index, targetData, newValue) => {
    const recordListCopy = [...contactDraft.records]

    if (targetData === 'expiryDate' || targetData === 'effectiveDate') {
      recordListCopy[index][targetData] = dayjs(newValue).format('YYYY-MM-DD')
    } else if (targetData === 'recordType') {
      recordListCopy[index][targetData] = newValue
      recordListCopy[index].recordTypeId = newValue
    } else if (targetData === 'recordLink') {
      recordListCopy[index][targetData] = newValue
      recordListCopy[index].recordUrl = recordUrlFormatter(newValue)
    } else {
      recordListCopy[index][targetData] = newValue
    }
    editPeopleData('records', recordListCopy)
  }

  const onClickContact = (contactData) => {
    switchFormTypeToManualInput()
    setContactDraft(contactData)
    setSelectedContactType(contactData.contactType)
  }

  const handleNext = () => {
    if (!disabled && peopleFormInProgress(contactDraft)) {
      setIsLeaveFormModalOpenNext(true)
    } else {
      onNext()
    }
  }

  const handlePrev = () => {
    if (peopleFormInProgress(contactDraft)) {
      setIsLeaveFormModalOpenPrev(true)
    } else {
      onPrev()
    }
  }

  const openRejectModal = () => {
    setRejectModalOpen(true)
  }

  const openApproveModal = () => {
    setApproveModalOpen(true)
  }

  const handleReject = () => {
    setRejectModalOpen(false)
    onReject()
  }

  const handleApprove = () => {
    setApproveModalOpen(false)
    onApprove()
  }

  useEffect(() => {
    if (selectedContactName) {
      const { contact_id, description, email_address, job_title, name, phone_number, records, contact_type } = selectedContactName
      const { firstName, lastName } = nameSeparator(name)
      const formattedRecordList = recordFormatter(records)
      const newDataFromSearch = {
        id: uuid(),
        contactId: contact_id,
        firstName: firstName,
        lastName: lastName,
        jobTitle: job_title,
        assignedDate: today,
        phoneNumber: phone_number,
        email: email_address,
        description: description || '',
        records: formattedRecordList,
        contactType: contact_type,
        contactTypeId: contactIdConverter(contact_type)
      }
      setSelectedContactList(prevState => {
        return { ...prevState, [contact_type]: [...prevState[contact_type], newDataFromSearch] }
      })
      setSelectedContact(null)
      setIsFormSuccessSnackbarOpen(true)
    }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [selectedContactName])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    const dataFromStorage = getItemFromSessionStorage('newContact')
    let contactType = []
    await ApiService().getAllContactType()
      .then((res) => {
        contactType = res
        setContactTypeList(res)
      })
      .catch((err) => {
        console.log(err)
      })

    if (dataFromStorage) {
      setSelectedContactList(dataFromStorage)
    } else {
      for (let i = 0; i < contactType.length; i++) {
        if (contactType[i].contact_type !== 'User') {
          // XXX Fix this in the future
          // eslint-disable-next-line
                    setSelectedContactList(prevState => {
            return { ...prevState, [contactType[i].contact_type]: [] }
          })
        }
      }
    }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [])

  const hasError = () => {
    const { firstName, lastName, organization, organizationName, jobTitle, phoneNumber, email, description, records } = contactDraft
    // First Name
    const firstNameValidation = validateFirstName(firstName)
    // Last Name
    const lastNameValidation = validateLastName(lastName)
    // Organization
    const organizationValidation = organization ? false : validateOrganizationName(organizationName)
    const searchOrganizationValidation = organizationName ? false : validateOrganizationName(organization)
    // Job Title
    const jobTitleValidation = validateJobTitle(jobTitle)
    // Phone Number
    const phoneNumberValidation = validatePhoneNumber(phoneNumber)
    // Email
    const emailAddressValidation = validateRequiredEmail(email)
    // Description
    const descriptionValidation = validateDescription(description)

    let recordsValidation = false
    for (let i = 0; i < records.length; i++) {
      const recordType = records[i].recordType
      const recordName = records[i].recordName
      const recordLink = records[i].recordLink
      const recordEffectiveDate = records[i].effectiveDate
      if (recordType || recordName || recordLink || recordEffectiveDate) {
        // Record Type
        if (validateRecordType(recordType)) {
          recordsValidation = true
          break
        }
        // Record Name
        if (validateRecordName(recordName)) {
          recordsValidation = true
          break
        }
        // Record Link
        if (validateOptionalRecordURL(recordLink)) {
          recordsValidation = true
          break
        }
        // Effective Date
        if (validateEffectiveDate(recordEffectiveDate)) {
          recordsValidation = true
          break
        }
      }
    }

    if (selectedContactType === 'Bee-Clean Contractor') {
      return (firstNameValidation || lastNameValidation || jobTitleValidation || phoneNumberValidation ||
                emailAddressValidation || descriptionValidation || recordsValidation || organizationValidation || searchOrganizationValidation)
    } else {
      return (firstNameValidation || lastNameValidation || jobTitleValidation || phoneNumberValidation ||
                emailAddressValidation || descriptionValidation || recordsValidation)
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.innerGrid}>
        <SidePeopleList
          selectedContactList={selectedContactList}
          deletePerson={deletePerson}
          setSelectedContactType={changeContactType}
          onClickContact={onClickContact}
          disabled={disabled}
        />

        <div className={classes.formDiv}>
          {selectedContactType
              ? (
                  <>
                      <Text type='smartFormInstruction'>Add New Person to <span>{selectedContactType}</span></Text>
                      {formType === 'Search Form' && (
                          <ContactNameSearch
                              value={selectedContactName} setValue={setSelectedContact}
                              onAdd={switchFormTypeToManualInput} selectedContactType={selectedContactType}
                            />
                        )}
                      {formType === 'Manual Input' && (
                          <PeopleForm
                              peopleData={contactDraft} editContactDraft={editContactDraft} addRecord={addRecord}
                              deleteRecord={deleteRecord} updateRecordData={updateRecordData} showError={showError}
                              addNewPerson={addNewPerson} switchToSearch={switchFormTypeToSearchForm}
                              updatePerson={updatePerson} selectedContactType={selectedContactType}
                              disabled={disabled}
                            />
                        )}
                    </>
                )
              : (
                  <SelectContactTypeInstruction />
                )}

          <ButtonLayoutDiv>
              {onCancel && (<CancelButton onClick={onCancel} />)}
              {onPrev && (<PrevButton onClick={handlePrev} />)}
              {onNext && (<NextButton onClick={handleNext} />)}
              {onReject && (<RejectButton onClick={openRejectModal} />)}
              {onApprove && (<ApproveButton onClick={openApproveModal} />)}
            </ButtonLayoutDiv>
        </div>
      </div>

      <FormErrorSnackbar isSnackbarOpen={isFormErrorSnackbarOpen} setIsSnackbarOpen={setIsFormErrorSnackbarOpen} />
      <ErrorSnackbar
        setIsSnackbarOpen={setFormCheckSnackbar} isSnackbarOpen={formCheckSnackbar}
        message='Add or Attach at least one contact'
      />
      <FormSuccessSnackbar isSnackbarOpen={isFormSuccessSnackbarOpen} setIsSnackbarOpen={setIsFormSuccessSnackbarOpen} />
      <SelectApproverModal
        isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} showError={showErrorApprover}
        onSubmit={onSave} approver={approver} setApprover={setApprover}
      />
      <LeaveFormModal open={isLeaveFormModalOpenPrev} setOpen={setIsLeaveFormModalOpenPrev} leaveHandler={onPrev} />
      <LeaveFormModal open={isLeaveFormModalOpenNext} setOpen={setIsLeaveFormModalOpenNext} leaveHandler={onNext} />
      <RejectModal
        rejectHandler={handleReject}
        open={rejectModalOpen}
        setOpen={setRejectModalOpen}
      />
      <ApproveModal
        approveHandler={handleApprove}
        open={approveModalOpen}
        setOpen={setApproveModalOpen}
      />
    </div>
  )
}

const useStyles = makeStyles({
  root: {
    height: '100%'
  },
  innerGrid: {
    display: 'grid',
    gridTemplateColumns: '330px 1fr',
    height: '100%'
  },
  formDiv: {
    padding: '12px 28px'
  }
})

export default PeopleImportTemplate
